var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 255,
    viewBox: "0 0 375 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9951 55.6069C13.9951 55.6069 9.99507 47.3069 6.79507 47.8069C3.59507 48.3069 -1.00494 45.4069 0.195062 41.1069C1.39506 36.8069 4.79507 36.1069 3.79507 33.8069C2.79507 31.5069 1.99506 28.4069 5.69506 24.4069C9.39506 20.4069 6.39507 13.9069 11.7951 11.5069C17.1951 9.10687 18.0951 12.2069 24.0951 6.50688C30.0951 0.806876 30.495 5.60688 36.495 1.10688C42.495 -3.39312 47.7951 7.40688 53.5951 5.50688C59.3951 3.60688 61.7951 9.50688 60.6951 16.6069C59.5951 23.7069 70.8951 23.5069 68.1951 28.5069C65.4951 33.5069 70.9951 35.5069 68.5951 40.5069C66.1951 45.5069 58.7951 52.1069 58.7951 52.1069L13.9951 55.6069Z",
    transform: "translate(239.305 0.346558)",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360 0V10H345V0H330V10H315V0H300V10H285V0H270V10H255V0H240V10H225V0H210V10H195V0H180V10H165V0H150V10H135V0H120V10H105V0H90V10H75V0H60V10H45V0H30V10H15V0H0V10V70H375V10V0H360Z",
    transform: "translate(0 135.953)",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360 0V10H345V0H330V10H315V0H300V10H285V0H270V10H255V0H240V10H225V0H210V10H195V0H180V10H165V0H150V10H135V0H120V10H105V0H90V10H75V0H60V10H45V0H30V10H15V0H0V10V70H375V10V0H360Z",
    transform: "translate(0 135.953)",
    fill: "url(#paint2_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360 0V10H345V0H330V10H315V0H300V10H285V0H270V10H255V0H240V10H225V0H210V10H195V0H180V10H165V0H150V10H135V0H120V10H105V0H90V10H75V0H60V10H45V0H30V10H15V0H0V10V70H375V10V0H360Z",
    transform: "translate(0 135.953)",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 0L46.2 25.6L51.2 88.4L0 100.3V108.4H86.2L77.5 0Z",
    transform: "translate(183.8 97.5535)",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45H0V12.5C0 5.6 5.6 0 12.5 0C19.4 0 25 5.6 25 12.5V45Z",
    transform: "translate(45 160.953)",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3 0L45.3 2.8L18.7 115.4L0 96.6V7L3.70001 5.4L35.3 0Z",
    transform: "translate(261.3 90.5535)",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60001 2.5V5.2C1.90001 6.2 0 8.8 0 11.9C0 15.8 3.20001 19 7.10001 19V9.2V4.8V0C5.80001 0 4.60001 1.1 4.60001 2.5Z",
    transform: "translate(246.4 39.6534)",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.2V2.5C2.5 1.1 1.4 0 0 0V4.8V9.3V19.1C3.9 19.1 7.10001 15.9 7.10001 12C7.10001 8.9 5.1 6.3 2.5 5.2Z",
    transform: "translate(296.5 39.6534)",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 15.677L27.8 14.577V0.577022C24.8 -2.22298 20.9 6.07702 16.5 6.07702C7.4 6.07702 0 13.477 0 22.577C0 28.877 3.49998 34.377 8.69998 37.177L12 51.077L15.4 39.177L15.3 39.077C15.7 39.077 16.1 39.177 16.6 39.177C25.7 39.177 33.1 31.777 33.1 22.677C33 20.077 32.4 17.777 31.5 15.677Z",
    transform: "translate(265.1 74.8765)",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2 22.1C45.2 22.4 45.2 22.7 45.2 23C45 31.1 43.2 38.1 34.8 40.7C32.5 41.4 29.6 41.9 26 42.1C25.4 43.3 24.1 44.2 22.6 44.2C21.1 44.2 19.9 43.3 19.2 42.1C15.7 41.9 12.8 41.4 10.4 40.7C2.00001 38.1 0.2 32.1 0 24C0 23.4 0 22.7 0 22.1C0 9.9 10.1 0 22.5 0C34.9 0 45.2 9.9 45.2 22.1Z",
    transform: "translate(252.3 18.4535)",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 93.5H0C4.5 60.1 12.2 29.3 26.1 0L27.5 20.5L42.2 93.5Z",
    transform: "translate(279.5 92.4534)",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 93.5H0C4.5 60.1 12.2 29.3 26.1 0L27.5 20.5L42.2 93.5Z",
    transform: "translate(279.5 92.4534)",
    fill: "url(#paint12_radial)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 7V17H0C1.3 7.4 9.50001 0 19.4 0C26 0 31.8 3.2 35.3 8.2L52.8 7Z",
    transform: "translate(207.2 188.953)",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0C44.7 14.7 41.6 59.2 22.5 59.2C3.4 59.2 0.3 15.7 0 1C0.2 9.1 1.99999 15.1 10.4 17.7C12.7 18.4 15.6 18.9 19.2 19.1C19.8 20.3 21.1 21.2 22.6 21.2C24.1 21.2 25.3 20.3 26 19.1C29.5 18.9 32.4 18.4 34.8 17.7C43 15.1 44.8 8.1 45 0Z",
    transform: "translate(252.5 41.4535)",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 0C13.9 2.8 11.1 4.6 7.79999 4.6C4.49999 4.6 1.8 2.8 0 0H15.6Z",
    transform: "translate(267.2 66.2534)",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 5.59999V13.7H0C1 6 7.59999 0 15.6 0C20.9 0 25.6 2.59999 28.4 6.59999L42.5 5.59999Z",
    transform: "translate(141.3 192.253)",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130 0H0V85H130V0Z",
    transform: "translate(120 90.9534)",
    fill: "url(#paint17_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75V10.5C36 4.7 31.3 0 25.5 0C19.7 0 15 4.7 15 10.5V75H5C2.2 75 0 77.2 0 80H15H36H55C55 77.2 52.8 75 50 75H36Z",
    transform: "translate(160 125.953)",
    fill: "url(#paint18_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z",
    transform: "translate(180 105.953)",
    fill: "url(#paint19_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0L22 0.0999985C22 0.199998 22.3 6.5 18.6 10.4C16.8 12.3 14.4 13.3 11.4 13.4C10.8 11.6 8.50002 10.3 5.80002 10.3C2.60002 10.3 0 12.1 0 14.4C0 16.7 2.60002 18.5 5.80002 18.5C8.50002 18.5 10.8 17.2 11.4 15.3C15 15.1 17.9 13.9 20.1 11.6C24.4 7.2 24 0.3 24 0Z",
    transform: "translate(274.4 58.3534)",
    fill: "url(#paint20_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M352.5 0H0V3H352.5V0Z",
    transform: "translate(22.5 205.953)",
    fill: "url(#paint21_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M100.61 116.5L23.0096 162.2C23.0096 162.2 -4.39039 133.5 0.609613 93.5H67.3096L52.6096 20.5L51.2096 0C67.9096 5.3 80.5096 19.2 84.0096 36.3L100.61 116.5Z",
    transform: "translate(254.391 92.4534)",
    fill: "url(#paint22_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.61 116.5L23.0096 162.2C23.0096 162.2 -4.39039 133.5 0.609613 93.5H67.3096L52.6096 20.5L51.2096 0C67.9096 5.3 80.5096 19.2 84.0096 36.3L100.61 116.5Z",
    transform: "translate(254.391 92.4534)",
    fill: "url(#paint23_radial)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V5H15V0Z",
    transform: "translate(23.2998 155.953)",
    fill: "url(#paint24_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V5H15V0Z",
    transform: "translate(8 160.953)",
    fill: "url(#paint25_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V5H15V0Z",
    transform: "translate(87.5 174.953)",
    fill: "url(#paint26_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V5H15V0Z",
    transform: "translate(102.5 179.953)",
    fill: "url(#paint27_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.73851 48.3157) scale(65.7619) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9949 71.9588) scale(309.01) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1288,
    stopColor: "#132E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.2911 -35.5834) scale(129.084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#162135",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.291 -35.2501) scale(129.084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#162135",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-13.7479 108.359) scale(113.68) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.0044 23.4588) scale(127.009) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.2232 116.359) scale(169.742) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8299 -14.0746) scale(24.4598) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3391 -23.0746) scale(59.6782) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-34.4231 30.8446) scale(89.5912) rotate(-69.608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-12.9252 59.7088) scale(71.2505) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-62.2085 147.217) scale(166.557) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.1959 18.9129) scale(72.4148 164.425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017BDF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4667 35.4717) scale(54.0258) rotate(180)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.25 -55.7912) scale(125.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7184 -0.1746) scale(15.8369) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.05 -14.4521) scale(42.5347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-42.8489 99.2921) scale(215.698) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-30.5193 88.6254) scale(116.039) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-15.3395 31.6254) scale(40.6789) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8347 -41.7746) scale(59.6781) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAC1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(289.5 195.96) scale(389.003) rotate(180)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-33.3482 147.88) scale(167.307) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-99.6758 67.1892) scale(195.962 169.487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0278DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-11.5648 12.2088) scale(38.0296) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-11.5148 12.2088) scale(38.0296) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.7522 7.9588) scale(28.5044) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.7522 7.9588) scale(28.5044) rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    stopColor: "#017BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59ABEE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.4db53574bac4845b4994cce107eec9ff.svg";
export { ForwardRef as ReactComponent };